import axios from 'axios';
import { mySubscriptionAction } from './MySubscriptionSlice';

const getMySubscriptionData = (token) => {
  return async (dispatch) => {
    const fetchData = async () => {
      const url = `${process.env.REACT_APP_DEV_URI}/user/subscription/plan`;
      const headers = { Authorization: `Bearer ${token}` };
      const response = await axios.get(url, { headers });
      return response;
    };
    try {
      const result = await fetchData();
      const mySubscriptionData = result.data;
      dispatch(mySubscriptionAction.mySubscriptionHandler({ mySubscriptionData }));
    } catch (e) {}
  };
};

export default getMySubscriptionData;